import React from 'react'
import { useTranslation } from 'react-i18next'
import Photo from './Photo'

const OthersPhotos = ({ item, canBuy = true }) => {
  const { t } = useTranslation()

  if (item.photos && item.photos.length > 1) {
    const otherPhotos = item.photos.slice(1) // Exclude main photo

    return (
      <div className="mt-4">
        <hr />
        <h2 className="mb-4">{t('SOME_PHOTOS')}</h2>
        <div className="other-photos-container">
          {otherPhotos.map((photo, index) => (
            <Photo
              key={index}
              photo={photo}
              isShortLine={index !== otherPhotos.length - 1}
              canBuy={canBuy}
            />
          ))}
        </div>
      </div>
    )
  }

  return null
}

export default OthersPhotos
